const MessageInput = () => {
  return (
    <div className="mt-6 box-border flex">
      <textarea
        placeholder="Type a message"
        className="font-lg box-border h-[48px] max-h-[96px] min-h-[48px] grow overflow-hidden border border-primary py-2.5 pl-7 font-pop text-chatLightGray placeholder:font-pop placeholder:text-lg placeholder:text-chatLightGray focus:outline-none"
        rows="1"
      ></textarea>
      <button className=" max-h-[48px] bg-primary py-2 px-12 font-pop text-xl text-white">
        Send
      </button>
    </div>
  );
};

export default MessageInput;
